import React from "react";
import { useLanguage } from "../../../../context/LanguageContext";

const StockStatus = ({ isOutOfStock, quantity }) => {
    const { language } = useLanguage();

    // Translations (refined)
    const translations = {
        en: {
            outOfStock: "Currently Unavailable",
            onlyLeft: "Only {quantity} left"
        },
        ar: {
            outOfStock: "غير متوفر حالياً",
            onlyLeft: "باقي {quantity} فقط"
        }
    };

    const t = translations[language] || translations.en;

    // Check if quantity is infinite (-1)
    const isUnlimited = parseInt(quantity) === -1;

    return (
        <div className="stock-status">
            {isOutOfStock ? (
                <span className="out-of-stock">{t.outOfStock}</span>
            ) : (
                <>
                    {!isUnlimited && quantity <= 5 ? (
                        <span className="few-left">
                            {t.onlyLeft.replace("{quantity}", quantity)}
                        </span>
                    ) : null}
                </>
            )}
        </div>
    );
};

export default StockStatus;
